import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { PrescriberForm } from "../PrescriberForm";
import { EditPrescriberModalProps } from "./types";
import { useEditPrescriberModal } from "./controller";

export const EditPrescriberModal = React.memo(({ modalRef, onComplete }: EditPrescriberModalProps) => {
  const translate = useTranslate();

  const { methods, handleSubmit, isPending } = useEditPrescriberModal({
    modalRef,
    onComplete,
  });

  return (
    <Modal
      ref={modalRef}
      title={translate("prescriber_admin.titles.edit")}
      onConfirm={handleSubmit}
      methods={methods}
      isPending={isPending}
    >
      <PrescriberForm />
    </Modal>
  );
});
